export default class PageBanner {
    contentVisible = false;

    init() {
        pegasus.parallaxScroll(this.$refs.paralaxScrollElem)
    }

}


document.addEventListener('alpine:init', () => {
    Alpine.data('pageBanner', () => new PageBanner());
});